import { render, staticRenderFns } from "./ChangelogEntryItem.vue?vue&type=template&id=9c5375be&scoped=true&"
import script from "./ChangelogEntryItem.vue?vue&type=script&lang=js&"
export * from "./ChangelogEntryItem.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogEntryItem.vue?vue&type=style&index=0&id=9c5375be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5375be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c5375be')) {
      api.createRecord('9c5375be', component.options)
    } else {
      api.reload('9c5375be', component.options)
    }
    module.hot.accept("./ChangelogEntryItem.vue?vue&type=template&id=9c5375be&scoped=true&", function () {
      api.rerender('9c5375be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangelogEntryItem.vue"
export default component.exports